import { Toaster } from "sonner";
import { ToastIcons } from "@/components/icons/ToastIcons";

export default function GlobalToaster() {
  return (
    <Toaster
      position="top-center"
      offset="64px"
      closeButton
      theme="system"
      icons={{
        success: ToastIcons.success,
        error: ToastIcons.error,
        warning: ToastIcons.warning,
        info: ToastIcons.info,
      }}
      toastOptions={{
        classNames: {
          toast:
            "!bg-background !text-foreground !border !border-border shadow-lg group",
          title: "!text-foreground",
          description: "!text-muted-foreground",
          actionButton: "!bg-primary !text-primary-foreground",
          cancelButton: "!bg-muted !text-muted-foreground",
          closeButton:
            "!absolute !left-auto !right-1 !top-1 !transform-none !bg-transparent !border-transparent hover:!bg-muted !text-muted-foreground",
          success: "!bg-background !text-foreground !border-border",
          error: "!bg-background !text-foreground !border-border",
          warning: "!bg-background !text-foreground !border-border",
          info: "!bg-background !text-foreground !border-border",
          loading: "!bg-background !text-foreground !border-border",
        },
      }}
    />
  );
}
